// @flow

import type { TranslateFn } from '../../controls/locale';

export const translateOfferType = (
  t: TranslateFn,
  offerType: 'buy' | 'rent',
): {|
  offerType: string,
  offerTypeVerb: string,
  offerTypeNoun: string,
  toOfferType: string,
  toOfferTypeNoun: string,
  forOfferType: string,
|} =>
  offerType === 'buy'
    ? {
        offerType: t('offerType_buy'),
        offerTypeVerb: t('offerType_buy_verb'),
        offerTypeNoun: t('offerType_buy_noun'),
        toOfferType: t('offerType_buy_to'),
        toOfferTypeNoun: t('offerType_buy_to_noun'),
        forOfferType: t('offerType_buy_for'),
      }
    : {
        offerType: t('offerType_rent'),
        offerTypeVerb: t('offerType_rent_verb'),
        offerTypeNoun: t('offerType_rent_noun'),
        toOfferType: t('offerType_rent_to'),
        toOfferTypeNoun: t('offerType_rent_to_noun'),
        forOfferType: t('offerType_rent_for'),
      };
